import * as React from 'react';
import styles from './index.less';
import { useParams, history } from 'umi';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import * as AHooks from 'ahooks';
import fSignResourceToNode from '@/components/fSignResourceToNode';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import fCollectionSelector from '@/components/fCollectionSelector';
import FAddResourcesHandleAuth from '@/components/FAddResourcesHandleAuth';
import FIcons from '@/components/FIcons';

interface SuccessProps {
  dispatch: Dispatch;
}

function Success({ dispatch }: SuccessProps) {
  const params = useParams<{ id: string }>();
  const [$resourceInfo, set$resourceInfo, get$resourceInfo] = FUtil.Hook.useGetState<null | {
    id: string;
    title: string;
    cover: string;
    name: string;
    type: string[];
    version: string;
  }>(null);

  AHooks.useMount(async () => {
    const {
      ret,
      errCode,
      msg,
      data: data_resource,
    } = await FServiceAPI.Resource.info({ resourceIdOrName: params.id });
    // console.log(data, 'DDD9wieojflksdjflksdjlfkjlkj');

    if (!data_resource || data_resource.userId !== FUtil.Tool.getUserIDByCookies()) {
      history.replace(FUtil.LinkTo.exception403());
      return;
    }

    set$resourceInfo({
      id: data_resource.resourceId,
      title: data_resource.resourceTitle,
      cover: data_resource.coverImages[0] || '',
      name: data_resource.resourceName,
      type: data_resource.resourceType,
      version: data_resource.latestVersion,
    });
  });

  const [$collectionID, set$collectionID, get$collectionID] = FUtil.Hook.useGetState<string>('');

  return (
    <>
      <div className={styles.Success}>
        <div style={{ flexGrow: 2 }} />
        <FIcons.FCheck style={{ fontSize: 76 }} />
        <div style={{ height: 30 }} />
        <div
          style={{
            color: '#666',
            lineHeight: '42px',
            fontSize: 30,
          }}
        >
          {FI18n.i18nNext.tAuto('resource_created_successfully')}
        </div>
        <div style={{ height: 60 }} />
        <div className={styles.resourceInfo}>
          <FCoverImage src={$resourceInfo?.cover || ''} width={68} />
          <div>
            <FComponentsLib.FContentText
              text={$resourceInfo?.name || ''}
              type={'highlight'}
              style={{ fontSize: 16, maxWidth: 265 }}
              singleRow={true}
            />
            <div style={{ height: 10 }} />
            <FComponentsLib.FContentText
              text={$resourceInfo?.type.join('/')}
              type={'additional2'}
            />
          </div>
        </div>
        <div style={{ height: 60 }} />
        <div className={styles.buttons}>
          <FComponentsLib.FTextBtn
            type={'primary'}
            onClick={() => {
              self.open(
                FUtil.LinkTo.resourceDetails({
                  resourceID: params.id,
                }),
              );
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}
          >
            <FIcons.FSetting style={{ fontSize: 14 }} />
            <span>
              {
                // 查看资源详情
                FI18n.i18nNext.tAuto('brr_completed_item_btn_viewdetails')
              }
            </span>
          </FComponentsLib.FTextBtn>
          <FHotspotTooltip
            id={'result.createResourceSuccess.manageMyResourceButton'}
            style={{ right: 16, bottom: -40 }}
            text={FI18n.i18nNext.tAuto('hotpots_rqr_viewresource')}
            onOpenChange={(o) => {
              if (o) {
                fSetHotspotTooltipVisible('result.createResourceSuccess.manageMyResourceButton', {
                  value: false,
                  effectiveImmediately: false,
                  onlyNullish: false,
                });
              }
            }}
          >
            <FComponentsLib.FTextBtn
              type={'primary'}
              onClick={() => {
                fSetHotspotTooltipVisible('result.createResourceSuccess.manageMyResourceButton', {
                  value: false,
                  effectiveImmediately: true,
                  onlyNullish: false,
                });
                self.open(
                  FUtil.LinkTo.resourceVersionInfo({
                    resourceID: params.id,
                    version: get$resourceInfo()?.version,
                  }),
                );
              }}
              style={{ display: 'flex', alignItems: 'center', gap: 5 }}
            >
              <FIcons.FSetting style={{ fontSize: 14 }} />
              <span>
                {
                  // 管理我的资源
                  FI18n.i18nNext.tAuto('brr_completed_btn_viewmyresource')
                }
              </span>
            </FComponentsLib.FTextBtn>
          </FHotspotTooltip>
          <FComponentsLib.FTextBtn
            type={'primary'}
            onClick={() => {
              self.open(FUtil.LinkTo.resourceCreatorEntry());
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}
          >
            <FIcons.FAdd style={{ fontSize: 14 }} />
            <span>
              {
                // 继续创建资源
                FI18n.i18nNext.tAuto('brr_completed_btn_moretorelease_single')
              }
            </span>
          </FComponentsLib.FTextBtn>

          <FComponentsLib.FTextBtn
            type={'primary'}
            onClick={async () => {
              const result = await fSignResourceToNode({
                resourceIDs: [params.id],
              });
              if (result) {
                if (result.allIsTheme) {
                  history.push(
                    FUtil.LinkTo.nodeManagement({ nodeID: result.nodeID, showPage: 'theme' }),
                  );
                } else {
                  history.push(FUtil.LinkTo.nodeManagement({ nodeID: result.nodeID }));
                }
              }
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}
          >
            <FIcons.FNodes style={{ fontSize: 14, color: 'inherit' }} />
            <span>{FI18n.i18nNext.tAuto('myresources_bulkaction_btn_addtomynode')}</span>
          </FComponentsLib.FTextBtn>

          <FComponentsLib.FTextBtn
            type={'primary'}
            onClick={async () => {
              const collectionID = await fCollectionSelector();
              const resourceInfo = get$resourceInfo();
              if (!collectionID || !resourceInfo) {
                return;
              }

              set$collectionID(collectionID);
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}
          >
            <FIcons.FResource style={{ fontSize: 14, color: 'inherit' }} />
            <span>
              {
                // 添加至合集
                FI18n.i18nNext.tAuto('brr_completed_btn_addtomycollection')
              }
            </span>
          </FComponentsLib.FTextBtn>
        </div>
        <div style={{ flexGrow: 3 }} />
      </div>

      <FAddResourcesHandleAuth
        collectionID={$collectionID}
        resourceIDs={[params.id]}
        onBack={async () => {
          set$collectionID('');
          const collectionID = await fCollectionSelector();
          if (!collectionID) {
            return;
          }
          set$collectionID(collectionID);
        }}
        onOk={() => {
          set$collectionID('');
        }}
        onCancel={async () => {
          set$collectionID('');
        }}
        onError={() => {
          set$collectionID('');
        }}
      />
    </>
  );
}

export default connect()(Success);
